import { useQuery } from 'react-query';
import { getQuestionAnswers } from '../../services/apis/QuestionAnswerApi';

const useQuestionAnswersQuery = (faceUserId, category) => {
	return useQuery(
		['questionAnswers', faceUserId, category],
		() => getQuestionAnswers({ faceUserId, category }),
		{
			enabled: Boolean(category),
			keepPreviousData: false,
		},
	);
};

export default useQuestionAnswersQuery;
